
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Chemburtopunecab() {



    const cardData =
    {
        keyword: ' Chembur to Pune Cab ',
        heading: 'Skyline Cabs: Chembur to Pune Cab ',
        headingDescription: 'Skyline Cabs provides dependable and convenient Chembur to Pune Cab service for all your intercity travel needs. Whether you are planning a business trip, visiting family, or going on a weekend getaway, our fleet of clean, well-maintained cars and experienced drivers ensures a smooth and safe ride. Enjoy on-time pickups from Chembur, transparent fare structure, and round-the-clock customer support with Skyline Cabs. Book your Chembur to Pune cab today and experience stress-free, comfortable travel.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Chembur to Pune Cab Fare",
    "description": "Skyline Cabs offers competitive and transparent pricing for taxi services from Chembur to Pune. We ensure that all taxes, tolls, and charges are included in the fare, providing you with a clear and affordable price for your journey. Choose from a range of vehicles based on your preferences and comfort."
  },
  {
    "name": "Chembur to Baner Cab Fare",
    "description": "For a reliable and affordable taxi service from Chembur to Baner, Skyline Cabs offers excellent fares and an array of vehicle options to choose from. Whether you're traveling for business or leisure, our experienced drivers ensure a comfortable and timely journey at the best prices."
  },
  {
    "name": "Chembur to Pimpri Chinchwad Cab Fare",
    "description": "Skyline Cabs offers affordable and transparent pricing for trips from Chembur to Pimpri Chinchwad. Whether you're traveling for work or visiting family, our fleet of vehicles ensures comfort and reliability, with no hidden charges in our pricing structure."
  },
  {
    "name": "Chembur to Pune Station Cab",
    "description": "Skyline Cabs provides convenient and affordable taxi services from Chembur to Pune Station. Our experienced drivers know the best routes to get you to the station quickly, ensuring you catch your train without any stress. Book your ride with us for a hassle-free experience."
  },
  {
    "name": "Chembur to Pune Shivaji Nagar Cab",
    "description": "Skyline Cabs offers reliable taxi services from Chembur to Shivaji Nagar in Pune. Whether you're traveling for business, meeting family, or just exploring, we ensure a safe, comfortable, and timely ride with our professional drivers. Our transparent pricing ensures no surprises along the way."
  },
  {
    "name": "Chembur to Koregaon Park Cab",
    "description": "Travel from Chembur to Koregaon Park in comfort and style with Skyline Cabs. Our fleet of vehicles, including sedans and SUVs, ensures a smooth ride, and our drivers are experienced in taking the best routes to ensure timely arrivals. Book with us for an affordable, reliable, and stress-free ride."
  },
  {
    "name": "Chembur to Pune Innova Crysta",
    "description": "Skyline Cabs offers premium Innova Crysta taxis for your journey from Chembur to Pune. Enjoy a luxury ride with ample space and comfort, perfect for families or group travel. Our experienced drivers ensure your safety while you enjoy the best amenities during your trip."
  },
  {
    "name": "Chembur to Pune Sedan Cabs",
    "description": "For a comfortable and affordable journey from Chembur to Pune, Skyline Cabs offers sedan taxi services. Our well-maintained vehicles ensure a smooth and relaxing ride, with transparent pricing and expert drivers who know the best routes to ensure you arrive on time."
  },
  {
    "name": "Chembur to Pune Taxi Fare",
    "description": "Skyline Cabs offers the best taxi fare from Chembur to Pune. Our pricing is clear and affordable, with no hidden charges. Whether you need a sedan, SUV, or any other vehicle type, we guarantee comfort and timely service at a competitive price."
  },
  {
    "name": "Chembur to Khardi Cab Fare",
    "description": "Skyline Cabs provides affordable and reliable taxi services from Chembur to Khardi. We ensure clear pricing with no surprises, and our drivers make sure you enjoy a comfortable ride. Whether it's a short trip or a long journey, we offer the best value for your travel."
  },
  {
    "name": "Chembur to Pune Cab",
    "description": "Skyline Cabs offers convenient and reliable taxi services from Chembur to Pune. Our fleet includes a range of vehicles, ensuring you have options for comfort, budget, and travel preferences. Our experienced drivers ensure that your ride is smooth and punctual."
  },
  {
    "name": "Chembur to Shivaji Nagar Cab",
    "description": "Travel in comfort from Chembur to Shivaji Nagar with Skyline Cabs. Our professional drivers will ensure a hassle-free ride, and our competitive pricing means you don’t have to worry about hidden charges. Choose from a variety of vehicles for a smooth and comfortable journey."
  },
  {
    "name": "Chembur to Pune One Way Cab",
    "description": "Skyline Cabs offers convenient one-way taxi services from Chembur to Pune. Perfect for those who need to travel in one direction only, our one-way rides are affordable, comfortable, and reliable. Our pricing is transparent, ensuring you pay only for the distance traveled."
  },
  {
    "name": "Pune to Sion Taxi Fare",
    "description": "Skyline Cabs provides affordable and transparent taxi services for your journey from Pune to Sion. Our pricing is competitive and includes all charges, ensuring there are no surprises. With a fleet of vehicles, we offer the best value for your trip, prioritizing comfort and punctuality."
  },
  {
    "name": "Taxi Service in Chembur Mumbai",
    "description": "Skyline Cabs offers reliable and affordable taxi services within Chembur, Mumbai. Whether you're traveling for a local trip or need an outstation ride, our fleet of vehicles is ready to meet your needs. We focus on comfort, punctuality, and safety, making your ride a pleasant experience."
  },
  {
    "name": "Best Taxi Service in Chembur Mumbai",
    "description": "Skyline Cabs is the best taxi service provider in Chembur, Mumbai. Our fleet of well-maintained vehicles, coupled with professional and courteous drivers, ensures you have a comfortable and timely ride. Whether it's a local commute or a long-distance trip, we provide the best service for all your travel needs."
  },
  {
    "name": "Best Taxi Service in Chembur Mumbai Contact Number",
    "description": "For the best taxi service in Chembur, Mumbai, contact Skyline Cabs at [Insert contact number]. Our friendly customer service team is available to help you book a ride, answer any questions, and ensure a smooth and hassle-free travel experience."
  }
],
"tableData": [
  ["Chembur to Pune Cab Fare", "Chembur to Baner Cab Fare"],
  ["Chembur to Pimpri Chinchwad Cab Fare", "Chembur to Pune Station Cab"],
  ["Chembur to Pune Shivaji Nagar Cab", "Chembur to Koregaon Park Cab"],
  ["Chembur to Pune Innova Crysta", "Chembur to Pune Sedan Cabs"],
  ["Chembur to Pune Taxi Fare", "Chembur to Khardi Cab Fare"],
  ["Chembur to Pune Cab", "Chembur to Shivaji Nagar Cab"],
  ["Chembur to Pune One Way Cab", "Pune to Sion Taxi Fare"],
  ["Taxi Service in Chembur Mumbai", "Best Taxi Service in Chembur Mumbai"],
  ["Best Taxi Service in Chembur Mumbai Contact Number", ""]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Chembur to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and punctual cab services from Chembur to Pune. Whether you’re traveling for work, a weekend getaway, or a family trip, we guarantee a smooth, timely, and comfortable ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars, ensuring a comfortable and relaxing journey. All vehicles are air-conditioned, spacious, and equipped with the latest amenities for a pleasant ride from Chembur to Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are highly trained and familiar with the best routes from Chembur to Pune. They prioritize your safety, comfort, and punctuality, ensuring a stress-free and enjoyable journey throughout."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers transparent pricing for your Chembur to Pune journey, with no hidden charges. You’ll always know the cost upfront, ensuring you get great value for your ride while enjoying top-quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs is available 24/7, allowing you to book your ride from Chembur to Pune anytime. Whether it’s a last-minute trip or a scheduled journey, we’re always ready to serve you."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your Chembur to Pune cab is simple and fast with Skyline Cabs. Use our website or mobile app to book your ride in just a few clicks and enjoy instant booking confirmation along with real-time ride tracking."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are thoroughly sanitized before each ride, and our drivers follow strict hygiene protocols to ensure that you travel in a clean, safe, and hygienic environment."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Skyline Cabs offers a wide range of vehicles to suit your needs. Whether you're traveling solo, with family, or in a group, we have the perfect vehicle for your Chembur to Pune trip—ranging from comfortable sedans to spacious SUVs."
    }
]




















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Chembur to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Chembur to Pune is simple and quick. You can book through our website, mobile app, or by calling our customer support team. Just enter your pickup and drop-off details, select your preferred vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Chembur to Pune trip?',
            answer:
                'We offer a variety of vehicles to suit your preferences, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle based on the number of passengers and your comfort requirements.',
        },
        {
            id: 3,
            question: 'How long will it take to travel from Chembur to Pune?',
            answer:
                'The travel time from Chembur to Pune typically ranges from 3.5 to 5 hours, depending on traffic conditions. Our professional drivers take the best routes to ensure you have a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Chembur to Pune cab fixed?',
            answer:
                'Yes, our fares are fixed, and we provide upfront pricing, including tolls, taxes, and driver fees. You’ll know the total cost before confirming your booking, ensuring complete transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Chembur to Pune?',
            answer:
                'Yes, you can easily book a round-trip cab. Simply provide your return trip details while booking, and we’ll take care of the rest, ensuring a comfortable return journey as well.',
        },
        {
            id: 6,
            question: 'Can I make modifications to my Chembur to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking via our website, app, or by contacting our customer support team. We offer flexible options to accommodate changes and cancellations.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Chembur to Pune well-maintained?',
            answer:
                'Absolutely! We ensure that all our vehicles are regularly maintained and thoroughly cleaned. We prioritize comfort and safety, ensuring you have a pleasant and worry-free ride.',
        },
        {
            id: 8,
            question: 'What payment options are available for my Chembur to Pune cab?',
            answer:
                'We offer secure online payment options such as credit/debit cards, UPI, and net banking. Alternatively, you can choose to pay in cash at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate travel from Chembur to Pune?',
            answer:
                'Yes, Skyline Cabs offers corporate travel services, providing reliable and comfortable transport for business meetings, conferences, or group travel. Contact us for tailored services that meet your corporate needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Chembur to Pune journey?',
            answer:
                'Skyline Cabs is known for its professional drivers, well-maintained vehicles, affordable pricing, and excellent customer service. We prioritize comfort, safety, and timely arrivals, ensuring you have a smooth, hassle-free journey from Chembur to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I traveled from Chembur to Pune for a weekend trip, and Skyline Cabs made it a comfortable experience. The car was clean and well-maintained, and the driver was polite and professional. I’ll definitely book again!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Had a good experience with Skyline Cabs for my Chembur to Pune journey. The ride was smooth, and the driver was punctual. It would’ve been perfect if the AC was a little cooler, but overall, I’m satisfied with the service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Chembur to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/chembur-to-pune-cab.jpg",
  "description": "Book Chembur to Pune cab with Skyline Cabs for a safe, comfortable, and on-time journey. Choose from AC sedans or SUVs driven by verified professionals—available 24/7 for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7264"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/chembur-to-pune-cab"
  }
};


     

    return (
        <div>


<Helmet>
  <title>Chembur to Pune Cab | AC Taxi Booking 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Chembur to Pune cab with Skyline Cabs for a safe, comfortable, and on-time journey. Choose from AC sedans or SUVs driven by verified professionals—available 24/7 for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Chembur to Pune Cab, Cab from Chembur to Pune, One-Way Taxi Chembur to Pune, Round Trip Cab Chembur to Pune, AC Cab Chembur to Pune, SUV Taxi Chembur to Pune, Affordable Taxi Chembur to Pune, Online Cab Booking Chembur to Pune, 24/7 Taxi Chembur to Pune, Skyline Cabs Chembur to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/50.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Chemburtopunecab;